











import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import Api from '@/project/http/Api.service';
import { BrandSearchPages } from '@/project/http/controllers/brandController';
import dictionaryService from '@/core/translation/dictionary.service';

@Component
export default class BrandCategoriesLinks extends Vue {
    @Prop()
    brandName!: string | null;

    @Prop()
    activeBrandCategory!: string;

    loading: boolean = true;
    brandLinksData: BrandSearchPages | null = null;
    categoryDisplayNames = new Map<string, string>();

    private async loadBrandLinks() {
        if (this.brandName) {
            this.brandLinksData = await Api.brand.brandSearchPages(this.brandName);
        } else {
            this.brandLinksData = null;
        }
    }

    private async loadCategoryNamesByIds(categoryIds: string[]) {
        const categories = await Api.navigation.categories(categoryIds);
        if (categories?.names) {
            Object.keys(categories.names).forEach((categoryId) => {
                this.categoryDisplayNames.set(categoryId, categories.names[categoryId]);
            });
        }
    }

    private async loadCategoryNames() {
        let categories: string[] = [];
        if (this.brandLinksFiltered?.length) {
            this.brandLinksFiltered.forEach(cat => {
                if (cat.displayName) {
                    const firstCategoryId = cat.categoryIds[0];
                    this.categoryDisplayNames.set(firstCategoryId, cat.displayName);
                } else {
                    categories = categories.concat(cat.categoryIds);
                }
            });
        }
        if (categories.length) {
            const uniqueCategories = categories.filter((e, i, a) => a.indexOf(e) === i);
            await this.loadCategoryNamesByIds(uniqueCategories);
        }
    }

    private get brandLinks() {
        return (!this.loading && this.brandLinksFiltered?.map(link => {
            if (!link.categoryIds?.length) return null;
            const index = link.categoryIds[0].toString();
            const name = this.categoryDisplayNames.get(index);
            return {
                ...link,
                displayName: name
            };
        })) || null;
    }

    private get brandLinksFiltered() {
        if (this.brandLinksData?.links && this.brandLinksData.links.length > 0) {
            return (this.activeBrandCategory ? this.brandLinksData.links.filter(c => !c.url.endsWith(this.activeBrandCategory)) : this.brandLinksData.links);
        }
        return null;
    }

    private get labelHeading():string {
        return dictionaryService.get(this.activeBrandCategory ? 'Brand.BrandOverview.BrandCategories.OtherCategories' : 'Brand.BrandOverview.BrandCategories', [this.brandLinksData?.brandName || '']);
    }

    @Watch('brandName', { immediate: true })
    async onBrandNameChange(newBrandName: string, oldBrandName: string) {
        this.loading = true;
        await this.loadBrandLinks();
        await this.loadCategoryNames();
        this.loading = false;
    }
}
